export default "__VITE_ASSET__15dee883__"